import React from "react";
import styled from "styled-components";
import { device } from "../../../../styles/BreakPoints";

const Contact = () => {
  return (
    <Section id="contact">
      <Subtitle>What’s Next?</Subtitle>
      <Title>Get In Touch</Title>
      <Description>
        Although I’m not currently looking for any new opportunities, my inbox
        is always open. Whether you have a question or just want to say hi, I’ll
        try my best to get back to you!
      </Description>
      <a href="mailto:tusharahmmedsakib@gmail.com">
        <BtnLink>Say Hello</BtnLink>
      </a>
    </Section>
  );
};

export default Contact;

const Section = styled.section`
  max-width: 600px;
  margin: 0px auto 100px;
  text-align: center;
  padding: 100px 0px;

  @media ${device.mdM} {
    padding: 80px 0px;
    margin: 0px auto 50px;
  }
  @media ${device.mobileL} {
    padding: 80px 0px;
    margin: 0px auto 0px;
  }
`;
const Subtitle = styled.h2`
  display: block;
  margin-bottom: 20px;
  color: var(--green);
  font-family: ${(props) => props.theme.fonts.sf};
  font-size: var(--fz-md);
  font-weight: 400;

  &::before {
    position: relative;
    content: "0.4";
    margin-right: 10px;
    color: var(--green);
    font-family: ${(props) => props.theme.fonts.sf};
    font-weight: 400;
  }
`;
const Title = styled.h2`
  font-size: clamp(40px, 5vw, 60px);
`;
const Description = styled.p`
  font-size: var(--font-sans);
  font-size: var(--fz-lg);
`;
const BtnLink = styled.a`
  color: var(--green);
  background-color: transparent;
  border: 1px solid var(--green);
  border-radius: var(--border-radius);
  padding: 1.25rem 1.75rem;
  font-size: var(--fz-sm);
  font-family: ${(props) => props.theme.fonts.sf};
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
  transition: var(--transition);
  display: inline-block;
  margin-top: 50px;

  &:hover {
    background-color: var(--green-tint);
  }
`;
